export const STEP_VIEW_BOOKINGS = {
  VIEW: 'VIEW',
  VIEW_OTP: 'VIEW_OTP',
  VIEW_APPOINTMENTS: 'VIEW_APPOINTMENTS',
  VIEW_APPOINTMENT: 'VIEW_APPOINTMENT',
  VIEW_APPOINTMENT_VIA_LINK: 'VIEW_APPOINTMENT_VIA_LINK',
  CANCEL: 'CANCEL',
  CANCEL_OTP: 'CANCEL_OTP',
  CANCEL_APPOINTMENTS: 'CANCEL_APPOINTMENTS',
  RESCHEDULE: 'RESCHEDULE',
  RESCHEDULE_LOCATION: 'RESCHEDULE_LOCATION',
  RESCHEDULE_DATETIME: 'RESCHEDULE_DATETIME',
  RESCHEDULE_OTP: 'RESCHEDULE_OTP',
  RESCHEDULE_APPOINTMENTS: 'RESCHEDULE_APPOINTMENTS',
};

export const MODIFY_TYPE = {
  CANCEL: 'CANCEL',
  RESCHEDULE: 'RESCHEDULE',
};

export const VIEW_BOOKING_SESSION_STORAGE = {
  STEP: 'step',
  CURRENT_APPOINTMENT: STEP_VIEW_BOOKINGS.VIEW_APPOINTMENT,
};
